import { sendTrackingEvent } from '../services/service.tracking';
import { getVehicleData, getVehicleQuestionData } from '../utils/utils.tracking';

export const trackVehicleHistoryLoad = () =>
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'impression',
    eventResult: 'ico_vehhist',
    eventNonInteractive: false,
    eventData: getVehicleQuestionData(),
  });

export const trackAutoCheckSelection = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: 'partner',
    eventAction: 'click',
    eventResult: `vehicle-history-report::autocheck`,
    eventNonInteractive: false,
    eventData: getVehicleData(),
  });
};
